import { GraduationCapIcon, UserCircleIcon, UsersIcon, UsersThreeIcon } from '@phosphor-icons/react';
import { useEffect, useMemo, useState } from 'react';

export default function ComparativeDifficultyTable({
  selectedSubject,
  comparativeDifficultyData,
  userDifficultyData,
  difficultyWiseQuestions,
  type,
}) {
  const [subjectUserDifficultyData, setSubjectUserDifficultyData] = useState(null);
  const [subjectComparativeDifficultyData, setSubjectComparativeDifficultyData] = useState(null);

  useEffect(() => {
    const subjectId = selectedSubject?.id?.toString?.();
    const tempUserDifficultyData = userDifficultyData?.find((item) => item?.subject_id?.toString?.() === subjectId);
    const tempComparativeDifficultyData = comparativeDifficultyData?.find(
      (item) => item?.subject_id?.toString?.() === subjectId,
    );

    setSubjectUserDifficultyData(tempUserDifficultyData || null);
    setSubjectComparativeDifficultyData(tempComparativeDifficultyData || null);
  }, [selectedSubject, userDifficultyData, comparativeDifficultyData]);

  const typeData = useMemo(() => {
    return (
      subjectComparativeDifficultyData?.values?.find(
        (item) => item?.title?.toLowerCase?.() === type?.toLowerCase?.(),
      ) || {}
    );
  }, [subjectComparativeDifficultyData, type]);

  const questionCount = difficultyWiseQuestions?.[selectedSubject?.title]?.[type] ?? 0;

  if (!subjectUserDifficultyData || !subjectComparativeDifficultyData) return null;

  return (
    <div className="overflow-x-auto rounded-b-xl border border-t-0 border-[var(--q3-stroke-light)]">
      <table className="text-sm w-full">
        <thead className="bg-[var(--q3-surface-dim)]">
          <tr className="h-16">
            <td className="py-3 px-4 w-[318px] text-start border-r border-[var(--q3-stroke-light)]">Students</td>
            <td className="py-3 px-4 min-w-[180px] text-center border-r border-[var(--q3-stroke-light)] text-[var(--q3-green-normal)]">
              Attempted Correct
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center border-r border-[var(--q3-stroke-light)] text-[var(--q3-danger-normal)]">
              Attempted Wrong
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center text-[var(--q3-neutral-light)]">Not Attempted</td>
          </tr>
        </thead>
        <tbody>
          {[
            {
              icon: <UserCircleIcon size={24} />,
              label: 'You',
              correct: subjectUserDifficultyData?.[`${type}Correct`] ?? 0,
              incorrect: subjectUserDifficultyData?.[`${type}Incorrect`] ?? 0,
              unattempted: subjectUserDifficultyData?.[`${type}Unattempted`] ?? 0,
            },
            /* {
              icon: <GraduationCapIcon size={24} />,
              label: 'Topper',
              correct: typeData?.values?.topper_correct ?? 0,
              incorrect: typeData?.values?.topper_incorrect ?? 0,
              unattempted: typeData?.values?.topper_unattempted ?? 0,
            }, */
            {
              icon: <UsersIcon size={24} />,
              label: 'Top 10%ile',
              correct: typeData?.values?.top_10_percent_correct ?? 0,
              incorrect: typeData?.values?.top_10_percent_incorrect ?? 0,
              unattempted: typeData?.values?.top_10_percent_unattempted ?? 0,
            },
            {
              icon: <UsersThreeIcon size={24} />,
              label: 'Top 25%ile',
              correct: typeData?.values?.top_25_percent_correct ?? 0,
              incorrect: typeData?.values?.top_25_percent_incorrect ?? 0,
              unattempted: typeData?.values?.top_25_percent_unattempted ?? 0,
            },
          ].map(({ icon, label, correct, incorrect, unattempted }, idx) => (
            <tr
              key={label}
              className={`h-16 ${idx !== 3 ? 'border-b border-[var(--q3-stroke-light)]' : ''} hover:bg-[var(--q3-surface-dim)]`}
            >
              <td className="border-r border-[var(--q3-stroke-light)] px-4">
                <div className="flex items-center gap-4 text-[var(--q3-neutral-default)]">
                  {icon}
                  <p className="truncate text-base font-semibold">{label}</p>
                </div>
              </td>
              <td className="text-center border-r border-[var(--q3-stroke-light)] text-[var(--q3-neutral-default)]">
                {correct}
                <span className="text-xs text-[var(--q3-neutral-light)]">/{questionCount}</span>
              </td>
              <td className="text-center border-r border-[var(--q3-stroke-light)] text-[var(--q3-neutral-default)]">
                {incorrect}
                <span className="text-xs text-[var(--q3-neutral-light)]">/{questionCount}</span>
              </td>
              <td className="text-center text-[var(--q3-neutral-default)]">
                {unattempted}
                <span className="text-xs text-[var(--q3-neutral-light)]">/{questionCount}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
